import { Action } from '../../xs/actions';

export class GetQuestionnaireAction implements Action {
  static readonly type = '[Scoring] get assessment';
}
